import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'fgbcl-streamable-player',
  standalone: true,
  imports: [],
  templateUrl: './streamable-player.component.html',
  styleUrls: ['./streamable-player.component.scss'],
})
export class StreamablePlayerComponent implements OnInit {
  @Input() streamKey: string;
  safeUrl: SafeResourceUrl;

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnInit() {
    this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.streamKey);
  }
}
